<template>
  <div class="dataset-prop-warpper">
    <Select v-model="datasetId" filterable size="small" style="width:120px">
        <div slot="empty">not Found data</div>
        <Option value="default-data">默认数据</Option>
        <Option v-for="item in datasetList" :value="item.id" :key="item.id">{{ item.name }}</Option>
    </Select>
    <a class="action-item" href="javascript:void(0)" @click="showEditDatasetDialog">查看</a>  
    <a class="action-item" href="javascript:void(0)" @click="showCreateDatasetDialog">创建</a>
    <CreateDatasetDialog ref="createDatasetDialog" @on-ok="createDataset" :format="format"></CreateDatasetDialog>
    <span>
        <EditDatasetDialog ref="editDatasetDialog" :datasetId="datasetId" @on-ok="updateDataset"></EditDatasetDialog>
        <ViewDatasetDialog ref="viewDatasetDialog" :data="this.value"></ViewDatasetDialog>
    </span>
  </div>
</template>
<style lang="less"> 
.dataset-prop-warpper {
    .action-item{
        margin-left: 3px;
    }
}
</style>
<script>
import CreateDatasetDialog from "@/datasets/view/create-dataset-dialog";
import EditDatasetDialog from '@/datasets/view/edit-dataset-dialog';
import ViewDatasetDialog from '@/datasets/view/view-dataset-dialog';
import * as datasetApi from '@/web/api/dataset';
export default {
  props: ["value", "metadata", "format"],
  components: { CreateDatasetDialog, EditDatasetDialog, ViewDatasetDialog},
  data() {
      return {
          datasetList:[
              {
                  id:11,
                  name:'测试数据集',
                  updateTime:Date.now()
              }
          ]
      }
  },

    computed:{
        datasetId:{
            get(){
                if(this.value&&this.value.datasetId){
                    return this.value.datasetId;
                }else{
                    return 'default-data';
                }
            },

            set(v){
                if(v==='default-data'){
                    this.$emit('input', this.metadata.default)
                }else{
                    this.$emit('input', {datasetId:v})
                }
            }
        }
    },
    mounted() {
        this.projectId = this.$route.query.project;
    },

  watch: {
      projectId:{
          handler(){
              this.getDatasets();
          },
          immediate:true
      }
  },
  methods: {
    showCreateDatasetDialog() {
        this.$refs.createDatasetDialog.show();
    },

    getDatasets(){
        let projectId = this.$route.query.project;
        return datasetApi.getDatasets(projectId).then((datasets)=>{
            if(datasets){
                let filterByFormat = datasets.filter(d=>{
                    try {
                        let config = JSON.parse(d.config);
                        return config.format===this.format||!config.format||!this.format;    
                    } catch (error) {
                        
                    }
                    return true;
                });    
                return this.datasetList = filterByFormat;
            }else{
                return this.datasetList = [];
            }
        })
    },

    createDataset(dataset){
        dataset.projectId = this.projectId;
        if(!dataset.config){
            dataset.config = "none";
        }
        return datasetApi.createDataset(dataset).then((data)=>{
            return this.getDatasets(this.projectId).then(()=>{
                this.datasetId = data.result;
                this.$nextTick().then(()=>{
                    this.showEditDatasetDialog()
                })
            });
        })
    },

    removeDataset(id){
        return datasetApi.removeDataset(id).then(()=>{
            return this.getDatasets(this.projectId);
        })
    },

    showEditDatasetDialog(){
        if(this.datasetId === 'default-data'){
            this.$refs.viewDatasetDialog.show();
        }else{
            this.$refs.editDatasetDialog.show();
        }
    },

    updateDataset(datasetInfo){
        return datasetApi.updateDataset(datasetInfo).then(()=>{
            let temp = this.datasetId;
            this.datasetId = 'default-data';
            this.$nextTick().then(()=>{
               this.datasetId = temp;
            })
        });
    }
  }
};
</script>